import { render, staticRenderFns } from "./ApiCall.vue?vue&type=template&id=438d1c6f&"
import script from "./ApiCall.vue?vue&type=script&lang=js&"
export * from "./ApiCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports